import { useEffect, useRef } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { applySeo, clearSeo } from '@/lib/seo'
import { useAppStore } from '@/lib/store'

export function SeoHead() {
  const { location } = useRouterState()
  const lang = useAppStore((state) => state.lang)
  const firstRender = useRef(true)
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      // Direct loads already have the authoritative server head. Keep it even offline.
      if (lang === 'uk' && document.head.querySelector('link[rel="canonical"]')) return
    }
    const controller = new AbortController()
    const url = new URL(window.location.href)
    const path = url.pathname.replace(/^\/app(?:\/|$)/, '').replace(/^\//, '')
    const params = new URLSearchParams({ path, lang })
    const category = url.searchParams.get('category')
    if (category && /^\d+$/.test(category)) params.set('category', category)
    // Remove metadata belonging to the previous page, including its structured data.
    clearSeo()
    void fetch(`/api/seo?${params}`, { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok && response.status !== 404) throw new Error('SEO unavailable')
        const html = await response.text()
        if (!controller.signal.aborted) applySeo(html)
      })
      .catch(() => {
        // Keep noindex on failure; never restore another route's canonical/schema.
      })
    return () => controller.abort()
  }, [location.pathname, location.searchStr, lang])
  return null
}
